"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Body(_ref) {
  var showLoader = _ref.showLoader,
      className = _ref.className,
      aside = _ref.aside,
      children = _ref.children,
      centerClass = _ref.centerClass,
      title = _ref.title;
  var bodyClass = (0, _classnames.default)(centerClass);
  var mainClassName = (0, _classnames.default)('main-content', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "flex w-full"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Loader, {
    show: showLoader
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: bodyClass
  }, title, /*#__PURE__*/_react.default.createElement("div", {
    className: mainClassName
  }, children)), aside);
}

Body.propTypes = {
  showLoader: _propTypes.default.bool,
  children: _propTypes.default.any,
  className: _propTypes.default.string,
  aside: _propTypes.default.any,
  centerClass: _propTypes.default.string,
  title: _propTypes.default.any
};
Body.defaultProps = {
  centerClass: 'w-full'
};
var _default = Body;
exports.default = _default;